import maskedText from '../constants/maskedText';
import _ from '../constants/gettext';

export const formatCurrency = (amount, locale = 'en-US', zeroAmountReplacement = true) => {
  if (isNaN(amount)) return maskedText.priceAmount;
  if (amount === 0 && zeroAmountReplacement) return _('LABEL_PRICE_INCLUDED');

  return amount.toLocaleString(locale, {
    style: 'currency',
    currency: locale === 'zh-CN' ? 'CNY' : 'USD'
  });
};
